import { render, staticRenderFns } from "./interactionChoiceItem.vue?vue&type=template&id=944a34ec"
import script from "./interactionChoiceItem.vue?vue&type=script&lang=js"
export * from "./interactionChoiceItem.vue?vue&type=script&lang=js"
import style0 from "./interactionChoiceItem.vue?vue&type=style&index=0&id=944a34ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports